import { Component } from '@angular/core';

@Component({
    selector: 'app-global-notification-widget',
    standalone: true,
    templateUrl: './globalnotification.component.html',
    styleUrls: ['./globalnotification.component.scss'],
})
export class GlobalNotificationWidget {}
